import { Pipe, PipeTransform } from '@angular/core';
import { CountryService } from '../providers/country.service';

@Pipe({
    name: 'roblexCountryImage',
})
export class CountryImagePipe implements PipeTransform {
    /**
     * Creates an instance of country pipe.
     * @param stateConfig StateConfig
     */
    constructor(private countryService: CountryService) {}
    /**
     * Transforms country pipe
     * @param value string
     * @returns string
     */
    transform(value: string): string {
        const country = this.countryService.getById(value);
        return country ? `assets/img/countries/${country?.id?.toLowerCase()}.svg` : value;
    }
}
